import React from 'react';
import { Redirect } from 'react-router-dom';
import { parseUrlParams } from '../../helpers/util';
import withUser from '../auth/withUser';
import Loader from '../shared/Loader';

class ChefOnboardingLogin extends React.Component {
  state = {
    isLoading: true
  };

  render() {
    return this.state.isLoading ? <Loader /> : <Redirect to="/new-chef" />;
  }

  componentDidMount() {
    const { search = '' } = this.props.location;
    if (!search) {
      this.setState({ isLoading: false });
      return;
    }

    const params = parseUrlParams(search);

    // set the auth headers
    const authHeaders = {
      client: params.client,
      uid: params.uid,
      accessToken: params['access-token'],
      expiry: params.expiry
    };
    localStorage.setItem('authHeaders', JSON.stringify(authHeaders));

    // {account_creation_state:0,email:"admin@culinistas.com",email_confirmed:true,id: 1}
    // set the logged in user
    const user = {
      id: parseInt(params.id, 10),
      email: params.uid,
      email_confirmed: true,
      role: 'chef',
      isAuth: true
    };
    this.props.loginOverride(user);
    this.setState({ isLoading: false });
  }
}
export default withUser(ChefOnboardingLogin);



// WEBPACK FOOTER //
// ./src/components/onboarding/ChefOnboardingLogin.js